{
  "pages": {
    "listTitle": "Thông báo",
    "permissionDenied": "Bạn không có quyền xem thông báo."
  },
  "types": {
    "all": "Tất cả loại",
    "appointment": "Lịch hẹn",
    "reminder": "Nhắc nhở",
    "patient": "Bệnh nhân",
    "inventory": "Kho",
    "payment": "Thanh toán",
    "treatment": "Điều trị",
    "system": "Hệ thống"
  },
  "priority": {
    "all": "Tất cả mức độ",
    "low": "Thấp",
    "medium": "Trung bình",
    "high": "Cao",
    "urgent": "Khẩn cấp"
  },
  "read": {
    "all": "Tất cả",
    "unread": "Chưa đọc",
    "read": "Đã đọc"
  },
  "table": {
    "title": "Tiêu đề",
    "type": "Loại",
    "priority": "Mức độ",
    "status": "Trạng thái",
    "time": "Thời gian",
    "actions": "Thao tác"
  },
  "filters": {
    "status": "Trạng thái",
    "type": "Loại",
    "priority": "Mức độ"
  },
  "actions": {
    "markAllRead": "Đánh dấu tất cả đã đọc",
    "markRead": "Đánh dấu đã đọc",
    "open": "Mở",
    "delete": "Xóa",
    "close": "Đóng",
    "refresh": "Làm mới"
  },
  "bell": {
    "title": "Thông báo",
    "onlyUnread": "Chỉ hiện chưa đọc",
    "empty": "Không có thông báo nào để hiển thị.",
    "emptyTitle": "Chưa có thông báo",
    "emptyUnread": "Bạn đã đọc hết thông báo gần đây.",
    "emptyUnreadTitle": "Đã đọc hết",
    "showAll": "Hiện tất cả thông báo",
    "viewAll": "Xem tất cả",
    "goToCenter": "Xem tất cả thông báo",
    "justNow": "Vừa xong",
    "minutesAgo": "{{count}} phút trước",
    "hoursAgo": "{{count}} giờ trước",
    "daysAgo": "{{count}} ngày trước"
  },
  "dialogs": {
    "detailTitle": "Chi tiết thông báo",
    "deleteTitle": "Xóa thông báo",
    "deleteConfirm": "Bạn có chắc muốn xóa thông báo này? Thao tác này không thể hoàn tác."
  },
  "empty": "Không có thông báo",
  "toasts": {
    "loadFailed": "Không tải được thông báo",
    "markReadSuccess": "Đã đánh dấu đã đọc",
    "markReadFailed": "Không đánh dấu thông báo là đã đọc được",
    "markAllSuccess": "Đã đánh dấu tất cả đã đọc",
    "markAllFailed": "Không đánh dấu tất cả là đã đọc được",
    "deleteSuccess": "Đã xóa thông báo",
    "deleteFailed": "Không xóa được thông báo",
    "actionFailed": "Thao tác thất bại"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
